export const DEFAULT_BG_COLOR = '#2e77eb'; // #007aff
export const DEFAULT_BG_TO_COLOR = undefined;
export const DEFAULT_BG_INPUT_TYPE = 'solid';
export const DEFAULT_TXT_COLOR = '#fff';
export const DEFAULT_FONT_TXT = 'Verdana';
export const DEFAULT_FONT_TITLE = undefined;
